import { FC } from 'react';
import { useDispatch } from 'react-redux';

import useSWR from 'swr';
import { BaseModal } from 'wbs-components-lib';

import { useUpdateVipTaskItemMutation } from '@services';

import { AppDispatch, updateVipTaskItems } from '@store';

import { VipTaskItemFormValues, VipTaskItemForm } from '../../VipSettingsForms';
import { getVipTaskItemSpecificFieldsValue } from '../utlis';

import { VipTaskItemEditModalProps } from './types';
import { getVipTaskItemFormValuesFromModel } from './utils';

import { tournamentsService } from 'v2/api/tournamentsService';

export const VipTaskItemEditModal: FC<VipTaskItemEditModalProps> = ({
  isOpened,
  handleClose,
  vipTaskItem,
  vipTaskType,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [updateCurrentItem, { isLoading: isUpdateInProgress }] = useUpdateVipTaskItemMutation();

  const { data: activeTournament } = useSWR('getActiveTournament', tournamentsService.getActiveTournament);

  const handleUpdateItem = async (values: VipTaskItemFormValues) => {
    const updatedItem = await updateCurrentItem({
      payload: {
        vipTaskId: vipTaskItem.id,
        ...values,
        ...getVipTaskItemSpecificFieldsValue(values),
      },
      vipTaskItemId: vipTaskItem.id,
    }).unwrap();

    dispatch(updateVipTaskItems(updatedItem));

    handleClose();
  };

  const initialValues = getVipTaskItemFormValuesFromModel(vipTaskItem);

  return (
    <BaseModal headerTitle="Edit VIP task item" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipTaskItemForm
        submitButtonCaption="Edit"
        initialValues={initialValues}
        vipTaskType={vipTaskType}
        activeTournamentId={activeTournament?.id}
        isSubmitting={isUpdateInProgress}
        onSubmit={handleUpdateItem}
      />
    </BaseModal>
  );
};
